export const GetTeamQuery = () =>{
    const query = `
    query{
        allTeamMembersUsingList{
          id,
          user{
            id,
            firstName,
            lastName,
            email,
            username,
            phoneNumber
          },
          isAdmin,
          customerAccount{
            id
          },
          userPerms{
            model,
            view,
            all
          }
          role,
          propertyIds
        }
      }
    `
    return query
}

const formatUserPermissions = (userPerms) => {
  let formattedPerms = "[";
  userPerms.forEach((perm, index) => {
    formattedPerms += `{model: "${perm.model}", view: ${perm.view}, all: ${perm.all}}`
  });
  formattedPerms += "]";
  return formattedPerms;
}

export const AddTeamMemberMutation = ( payload) => {
    let roleStr = "";
    let role = payload.role || "";
    if(role){
      roleStr = `role: "${role}",`
    }

    let propertyIdsStr = "";
    let propertyIds = payload.propertyIds || [];
    if(propertyIds && propertyIds.length > 0){
      propertyIdsStr = `propertyIds: ${JSON.stringify(propertyIds)},`
    }

    const mutation = `
    mutation{
        addTeamMember(
          username: "${payload.username}",
          firstName:"${payload.firstName}", 
          lastName:"${payload.lastName}", 
          email:"${payload.email}",
          phoneNumber:"${payload.phoneNumber}",
          userPerms: ${formatUserPermissions(payload.userPerms)},
          ${roleStr}
          ${propertyIdsStr}
          ){
            errors
            teamMember{
              id,
              user{
                id,
                username,
                firstName,
                lastName,
                email,
                phoneNumber
              },
              isAdmin
              customerAccount{
                id
              }
              userPerms{
                model,
                view,
                all
              }
              role,
              propertyIds
            }
        }
      }
    `
    return mutation;
}

export const UpdateTeamMemberMutation = (payload) => {
    let roleStr = "";
    let role = payload.role || "";

    if(role){
      roleStr = `role: "${role}",`
    }

    let propertyIdsStr = "";
    let propertyIds = payload.propertyIds || [];
    if(propertyIds && propertyIds.length > 0){
      propertyIdsStr = `propertyIds: ${JSON.stringify(propertyIds)},`
    }
    const mutation = `
    mutation{
        updateTeamMember(
        id:${JSON.stringify(payload.personId)}
        firstName:"${payload.firstName}", 
        lastName:"${payload.lastName}", 
        email:"${payload.email}",
        phoneNumber:"${payload.phoneNumber}",
        userPerms: ${formatUserPermissions(payload.userPerms)},
        ${roleStr}
        ${propertyIdsStr}
        ){
          errors
          teamMember{
              id,
              user{
                id,
                username
                firstName,
                lastName,
                email,
                phoneNumber
              },
              isAdmin,
              customerAccount{
                id
              }
              userPerms{
                model,
                view,
                all
              }
              role,
              propertyIds
          }
    }
    }
    `
    return mutation;
}

export const DeleteTeamMemberMutation = (personId) => {
    const mutation = `
    mutation{
        deleteTeamMember(id:${JSON.stringify(personId)}){
          success
          errors
        }
      }
    `
    return mutation
  }
